<template>
    <div class="canvas">
        <el-row class="canvas-title mt-60" :gutter="30">
            <el-col :span="5">
                <div :class="tabFlg==='1'?'item2':'item3'" @click="tabChange('1')">行业活动<img class="icon" src="../../assets/images/gain-jt.png"></div>
            </el-col>
            <el-col :span="4">
                <div :class="tabFlg==='2'?'item2':'item3'" @click="tabChange('2')">行业发展</div>
            </el-col>
            <el-col :span="15">
                <div class="text-right" @click="goHome">返回首页<img src="../../assets/images/fanhui.svg" alt="" /></div>
            </el-col>
        </el-row>
        <InfoList :list="list" @handleDetail="getDocInfo" />
        <div class="page mb-40 mt-40">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="param.pageIndex"
                :page-size="param.pageSize"
                :page-sizes="[10, 15, 20, 30]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {
    getIndustryActivityDateListApi,
    getIndustryDevelopListApi
} from "@/api"
import InfoList from '@/components/InfoList/InfoList'
export default {
    components:{
        InfoList
    },
    data () {
        return {
            list:[],
            total:0,
            param:{
                pageIndex:1,
                pageSize:10,
            },
            tabFlg:'1'
        }
    },
    watch: {
        $route: {
            handler: function(val){
                this.tabFlg = val.query.tab
                this.tabChange(this.tabFlg)
            }
        }
    },
    created(){
        this.tabFlg = this.$route.query.tab?this.$route.query.tab:'1'
        this.getlist(this.param, this.tabFlg)
    },
    methods: {
        async getlist(param, flg){
            let returnList = []
            if (flg === '1') {//行业活动
                const { data } = await getIndustryActivityDateListApi(param)
                if(data){
                    this.total = data.count
                    if (data.list){
                        data.list.forEach(item => {
                            let info = {
                                docId: item.doc_id,
                                title: item.activity_title,
                                content: item.activity_content,
                                imgUrl: item.img_url,
                                showDate: item.showDate
                            }
                            returnList.push(info)
                        })
                    }
                    this.list = returnList
                }
            } else {//行业发展
                const { data } = await getIndustryDevelopListApi(param)
                if(data){
                    this.total = data.count
                    if (data.list){
                        data.list.forEach(item => {
                            let info = {
                                docId: item.doc_id,
                                title: item.industry_title,
                                content: item.industry_content,
                                imgUrl: item.img_url,
                                showDate: item.showDate
                            }
                            returnList.push(info)
                        })
                    }
                    this.list = returnList
                }
            }

        },
        getDocInfo(docId){
            this.$router.push({
                path: '/DetailsPage',
                query: {
                    docId: docId,
                    position: '/IndustryDynamic',
                    positionName: '行业动态'
                }
            }, () => {})
        },
        tabChange(flg){
            this.tabFlg = flg            
            this.getlist(this.param, flg)
        },
        handleSizeChange(val){
            this.$set(this.param, 'pageSize', val)
            this.getlist(this.param, this.tabFlg)
        },
        handleCurrentChange(val){
            this.$set(this.param, 'pageIndex', val)
            this.getlist(this.param, this.tabFlg)
        },
        goHome(){
            this.$router.push({
                path: '/home'
            }, () => {})
        }
    }
}
</script>

<style lang="scss" scoped>
.canvas{
    width: calc(var(--minScreen) * 0.7);
    text-align: center;
    margin: 0 auto;
    &-title{
        width: 100%;
        text-align: left;
        position: relative;
           padding-left: 0;
            .item2{
                cursor: pointer;
                background-color: #134B9F;
                color: #fff;
                border: 1px solid #134B9F;
                text-align: center;
                line-height:36px;
                font-size:var(--notice-bt);
                width:var(--notice-btW);
                height: 40px;   
                .icon{
                    margin-left:9px;
                    margin-bottom: 2px;
                    width: 6.5px;
                    height: 8px;
                }
            }
            .item3{
                cursor: pointer;
                color: #134B9F;
                border: 1px solid #134B9F;
                text-align: center;
                line-height: var(--notice-btL);
                font-size:var(--notice-bt);
                background-color: #FFF;
                width: var(--notice-btW);
                height: 40px;   
                line-height:36px;
                font-weight: 500;
            }
            .text-right{
                justify-items: flex-end;
                color: #134B9F;
                font-size: 19px;
                cursor: pointer;
                img{
                    width: 28px;
                }
            }
    }
}


</style>
